import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import CandidateTab from "./CandidateTab";
import NotificationPanels from "./NotificationPanels";
import PersonalDetailsIcon from "../assets/img/personal-details-icon.png";
import "../assets/css/candidate-tab-form.css";
import BagIcon from "../assets/img/bag-icon.svg";
import CallIcon from "../assets/img/call-icon.png";
import EmailIcon from "../assets/img/email-icon.png";
import ABUpload from "./Common/ABUpload";
import ABDate from "./Common/ABDate";
import ABYear from "./Common/ABYear";
import DownloadIconBlack from "../assets/img/download-icon-black.svg";
import Footer from "./Footer.js";
import StepCount from "./Common/StepCount";
import ClientSideBar from "./Partials/ClientSideBar";
import ClientHeader from "./Partials/ClientHeader";
import { useDispatch, useSelector } from "react-redux";
import ProgressHeading from "./Common/ProgressHeading.jsx";

const CandidateProfessionalLicenceCheck = () => {
  //Handling Form Reference
  const form = useRef();
  const [role,setRole]=useState();

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }

  //Handling Initial States Floating Labels
  const [formData, setFormData] = useState({
    courseName: null,
    instituteName: null,
    instituteLocation: null,
    licenceNumber: null,
  });

  //Handling Floating Labels
  const handleFloatingLabels = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      
     setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);

  return (
    <>
      <NotificationPanels />
      {role=="EP"? <ClientHeader />:<Header/>}
      {role=="EP"? <ClientSideBar /> :<Sidebar/>}
      {/* <Header />
      <Sidebar /> */}

      <section
        className="main-section candidate-tab-form"
        style={{ paddingTop: "60px" }}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-auto w-100-mbl bg-gray-mbl">
              <ProgressHeading/>
              <CandidateTab activeTab={"professionalLicenceCheck"} />
            </div>
            <div className="col bg-gray-mbl">
              {/*Form*/}

              <form ref={form} className="p-3 form2 form-section">
              <StepCount activeTab={"professionalLicenceCheck"}/>
                <h2 className="fnt-smi-bld">Professional Licence Check</h2>
                <p className="text-muted">
                  detail about your qualification which requires licence to
                  practice like CA, doctor, lawer etc.
                </p>
                <hr />

                <h6 className="fnt-smi-bld mb-3">
                  Do you have any qualification which requires licence to
                  practice like CA, doctor, lawer etc.
                </h6>

                <div className="row mb-3">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-check form-check-inline mr-4">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="referenceCheckYesNo"
                        id="referenceCheckYes"
                        value="Yes"
                        checked="true"
                      />
                      <label
                        htmlFor="referenceCheckYes"
                        className="form-check-label"
                      >
                        Yes
                      </label>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        className="form-check-input"
                        name="referenceCheckYesNo"
                        id="referenceCheckNo"
                        value="No"
                      />
                      <label
                        htmlFor="referenceCheckNo"
                        className="form-check-label"
                      >
                        No
                      </label>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input
                          type="text"
                          className="form-control"
                          name="courseName"
                          id="courseName"
                          onChange={handleFloatingLabels}
                        />
                        <label
                          htmlFor="courseName"
                          className={formData.courseName && "focused"}
                        >
                          Course name/Qualification
                          <sup className="text-danger">*</sup>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input
                          type="text"
                          className="form-control"
                          name="instituteName"
                          id="instituteName"
                          onChange={handleFloatingLabels}
                        />
                        <label
                          htmlFor="instituteName"
                          className={formData.instituteName && "focused"}
                        >
                          Institute Name<sup className="text-danger">*</sup>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input
                          type="text"
                          className="form-control"
                          name="instituteLocation"
                          id="instituteLocation"
                          onChange={handleFloatingLabels}
                        />
                        <label
                          htmlFor="instituteLocation"
                          className={formData.instituteLocation && "focused"}
                        >
                          Institute Location
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <input
                          type="text"
                          className="form-control"
                          name="licenceNumber"
                          id="licenceNumber"
                          onChange={handleFloatingLabels}
                        />
                        <label
                          htmlFor="licenceNumber"
                          className={formData.licenceNumber && "focused"}
                        >
                          Licence Number
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <p></p>
                <h6 className="fnt-smi-bld mb-0">Upload File</h6>
                <small className="text-muted">Upload related documents</small>
                <p></p>

                <ABUpload
                  name="license"
                  id="license"
                  title="Professional Licence"
                />

                <div className="row mt-3">
                  <div className="col-auto d-flex justify-content-between">
                    <button className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2">
                      Back
                    </button>
                    <button className="btn btn-primary btn-lg btn-block mt-3">
                      Save
                    </button>
                  </div>
                </div>
              </form>

              {/*Form*/}
              <div className="mt-4">
                <div className="row mb-3">
                  <div className="col-md-12 d-flex align-items-center btn-and-info-responsive">
                    <button className="btn btn-primary btn-lg mr-3">
                    {clientId == 459831 ? "Preview" : "Submit for Preview"}
                    </button>
                    <span className="text-muted">
                      Please complete the all mandatory fields before final
                      submission
                    </span>
                  </div>
                </div>
              </div>
              <Footer />
              <Footer/>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default CandidateProfessionalLicenceCheck;
